import EmailInfo from "components/EmailInfo";

export default EmailInfo;
